import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageTitle, Panel, Field, TextInput, TextArea, Btn, StatCard } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

export default function Gri() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { CL.getGri().then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const a = d.auto || {};
  const up = (k) => (e) => { const v = e.target.value; setD((p) => ({ ...p, [k]: v })); };
  const num = (v) => (v === "" || v == null ? 0 : Number(v));

  const save = async () => {
    setSaving(true);
    try {
      await CL.putGri({ methodology: d.methodology || "GHG Protocol", base_year: num(d.base_year) || 2024,
        gases_included: d.gases_included || "", consolidation_approach: d.consolidation_approach || "", reductions_note: d.reductions_note || "" });
      toast.success(t("saved"));
    } catch { toast.error("Error"); } finally { setSaving(false); }
  };

  return (
    <div data-testid="gri-page">
      <PageTitle title={t("griTitle")} subtitle={t("griDesc")} />
      <div className="mb-6 grid grid-cols-2 gap-4 md:grid-cols-4">
        <StatCard testId="gri-1" label="305-1 (Kapsam 1)" value={(a.d305_1_t ?? 0).toLocaleString()} sub={t("tCO2e")} />
        <StatCard testId="gri-2" label="305-2 (Kapsam 2)" value={(a.d305_2_t ?? 0).toLocaleString()} sub={t("tCO2e")} accent="#2f8f5b" />
        <StatCard testId="gri-3" label="305-3 (Kapsam 3)" value={(a.d305_3_t ?? 0).toLocaleString()} sub={t("tCO2e")} accent="#e08a1e" />
        <StatCard testId="gri-4" label="305-4 (Yoğunluk)" value={a.d305_4_intensity ?? "—"} />
      </div>
      <Panel className="max-w-3xl">
        <div className="grid grid-cols-2 gap-5">
          <Field label={t("methodology")}><TextInput data-testid="gri-method" value={d.methodology || ""} onChange={up("methodology")} /></Field>
          <Field label={t("baseYear")}><TextInput type="number" data-testid="gri-base" value={d.base_year ?? ""} onChange={up("base_year")} /></Field>
          <Field label={t("gasesIncluded")}><TextInput data-testid="gri-gases" value={d.gases_included || ""} onChange={up("gases_included")} /></Field>
          <Field label={t("consolidation")}><TextInput data-testid="gri-consol" value={d.consolidation_approach || ""} onChange={up("consolidation_approach")} /></Field>
        </div>
        <div className="mt-4"><Field label={t("reductionsNote")}><TextArea data-testid="gri-reductions" value={d.reductions_note || ""} onChange={up("reductions_note")} /></Field></div>
        <div className="mt-6"><Btn onClick={save} disabled={saving} data-testid="gri-save">{saving ? "..." : t("save")}</Btn></div>
      </Panel>
    </div>
  );
}
